<template>
  <div id="basicInfo">
    <!-- 分销商 -->
    <div class="header">
      <div class="operation-btns">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          unlink-panels
          :clearable="false"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getReportData"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
      <div class="filters">
        <el-select
          v-model="query.organizationUnitId"
          @change="getReportData"
          filterable
          remote
          :remote-method="remoteMethod"
          @clear="clear"
          placeholder="请输入渠道部门名称"
          class="handle-select"
          clearable
        >
          <el-option
            v-for="item in orgList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-button
          class="updown"
          type="primary"
          plain
          @click="exportStatistics"
          >导出</el-button> -->
      </div>
    </div>
    <div class="main">
      <div id="marketingChart"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { filterSpaceTime } from "@/common/filters";
import { getChannelTrendStatistics } from "@/http/api/report";
import { format } from "echarts/lib/export";
import { getOrgsSearch } from "@/http/api/organization";

import { dateFormat } from "@/common/filters";
export default {
  data() {
    return {
      daterange: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 30),
        new Date(),
      ],
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime()>new Date(new Date().toLocaleDateString()).getTime()-1
          ); 
        },
      },
      query: {
        startTime: null,
        endTime: null,
        organizationUnitId:"",
      },
      orgList: [],
      searchFilter: "",
      tntryTrendData: [],
      isLoading: true,
      typeDic: { Now: "立即发布", Timing: "定时发布", None: "暂不发布" },
    };
  },
  mounted() {
    this.getReportData();
  },
  methods: {
    remoteMethod(query) {
      if (query) {
        this.searchFilter = query;
        this.getOrgsSearch();
      }else{
        this.orgList=[]
      }
    },
    clear() {
      this.searchFilter = "";
      this.orgList=[]
    },
    // 获取分销商门店列表
    getOrgsSearch() {
      this.companies = [];
      let query = { filter: "" };
      if (this.searchFilter) {
        query.filter = this.searchFilter;
      } else {
        delete query.filter;
      }
      getOrgsSearch(query).then((res) => {
        this.orgList = res.result.items;
      });
    },
    tntryTrendChart(tntryTrendData) {
      var date = [],
        reservationCount = [],
        visitCount = [],
        recognitionCount = [],
        netSignCount = [],
        commissionCount = [],
        refundCount = [],
        storeCount = [],
        brokerCount = [];
      for (let tntryTrend of tntryTrendData) {
        date.push(filterSpaceTime(tntryTrend.time));
        reservationCount.push(tntryTrend.reservationCount);
        visitCount.push(tntryTrend.visitCount);
        recognitionCount.push(tntryTrend.recognitionCount);
        netSignCount.push(tntryTrend.netSignCount);
        commissionCount.push(tntryTrend.commissionCount);
        refundCount.push(tntryTrend.refundCount);
        storeCount.push(tntryTrend.storeCount);
        brokerCount.push(tntryTrend.brokerCount);
      }

      let myChart = echarts.init(document.getElementById("marketingChart"));
      let option = {
        // title: {
        //   text: "折线图堆叠"
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["报备", "带看", "认购", "网签", "结佣", "退订","分销商门店","经纪人"],
          x: "center", // 'center' | 'left' | {number},
          y: "bottom", // 'center' | 'bottom' | {number}
        },
        grid: {
          top: "20px",
          left: "0",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        series: [
          {
            name: "报备",
            type: "line",
            data: reservationCount,
            itemStyle: {
              normal: {
                color: "#0A89FF", //改变折线点的颜色
                lineStyle: {
                  color: "#0A89FF", //改变折线颜色
                },
              },
            },
          },
          {
            name: "带看",
            type: "line",
            data: visitCount,
            itemStyle: {
              normal: {
                color: "#2DC25A", //改变折线点的颜色
                lineStyle: {
                  color: "#2DC25A", //改变折线颜色
                },
              },
            },
          },
          {
            name: "认购",
            type: "line",
            data: recognitionCount,
            itemStyle: {
              normal: {
                color: "#FACA0B", //改变折线点的颜色
                lineStyle: {
                  color: "#FACA0B", //改变折线颜色
                },
              },
            },
          },
          {
            name: "网签",
            type: "line",
            data: netSignCount,
            itemStyle: {
              normal: {
                color: "#202F71", //改变折线点的颜色
                lineStyle: {
                  color: "#202F71", //改变折线颜色
                },
              },
            },
          },
          {
            name: "结佣",
            type: "line",
            data: commissionCount,
            itemStyle: {
              normal: {
                color: "#00BEBE", //改变折线点的颜色
                lineStyle: {
                  color: "#00BEBE", //改变折线颜色
                },
              },
            },
          },
          {
            name: "退订",
            type: "line",
            data: refundCount,
            itemStyle: {
              normal: {
                color: "#7E36DF", //改变折线点的颜色
                lineStyle: {
                  color: "#7E36DF", //改变折线颜色
                },
              },
            },
          },
          {
            name: "分销商门店",
            type: "line",
            data: storeCount ,
            itemStyle: {
              normal: {
                color: "#F2637B", //改变折线点的颜色
                lineStyle: {
                  color: "#F2637B", //改变折线颜色
                },
              },
            },
          },
          {
            name: "经纪人",
            type: "line",
            data: brokerCount,
            itemStyle: {
              normal: {
                color: "#A3A1FF", //改变折线点的颜色
                lineStyle: {
                  color: "#A3A1FF", //改变折线颜色
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    getReportData() {
      if (this.daterange) {
        this.query.startTime = dateFormat(this.daterange[0]);
        this.query.endTime = dateFormat(this.daterange[1]);
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      getChannelTrendStatistics(this.query).then((res) => {
        this.tntryTrendData = res.result.items;
        this.tntryTrendChart(this.tntryTrendData);
      });
    }
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#basicInfo {
  .header {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: $--border-radius-base;
    .operation-btns,
    .filters {
      @include flex(row, center);
      .el-select {
        width: 200px;
        margin-left: 5px;
      }
      .input-with-select {
        width: 400px;
        .el-select {
          width: 110px;
        }
      }
      .updown {
        margin-left: 5px;
      }
    }
  }
  .main {
    padding: 20px;
    width: calc(100% - 40px);
    background: #fff;
  }
  #marketingChart {
    width: 100%;
    height: calc(100vh - 250px);
  }
}
</style>
